import { render, staticRenderFns } from "./onFocus-editor.vue?vue&type=template&id=88d9fc54&scoped=true"
import script from "./onFocus-editor.vue?vue&type=script&lang=js"
export * from "./onFocus-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d9fc54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88d9fc54')) {
      api.createRecord('88d9fc54', component.options)
    } else {
      api.reload('88d9fc54', component.options)
    }
    module.hot.accept("./onFocus-editor.vue?vue&type=template&id=88d9fc54&scoped=true", function () {
      api.rerender('88d9fc54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onFocus-editor.vue"
export default component.exports